import { DiffEditor } from '@monaco-editor/react'
import { Suspense, useDeferredValue } from 'react'

import { Button } from '@ui/components/core'
import { sizeInBytes } from '@ui/lib/utils'
import { useTabSelectorStore } from '@ui/stores'

export function DiffView(props: { input: any; output: any; height: string }) {
  // we do this mess because otherwise changing the code in the editor won't refresh the diff code.
  // Not to mention, we have things like offsets/page numbers that need to be in state that are just variables in the Table component
  const setCurrentTab = useTabSelectorStore((state) => state.setCurrentTab)

  const { input, output } = props

  const jsonInput = JSON.stringify(input, null, 2)
  const jsonOutput = JSON.stringify(output, null, 2)

  const deferredInput = useDeferredValue(jsonInput)
  const deferredOutput = useDeferredValue(jsonOutput)

  return (
    <div className="flex flex-col">
      {/* Top  */}
      <div className="flex w-full flex-row bg-white">
        <div className="flex h-full w-1/2 flex-row items-center justify-between border-l border-gray-300 px-2.5">
          <h2 className="text-sm font-semibold">Input</h2>
          <div className="mr-3 flex flex-row items-center">
            <div className="mr-4">
              <Button variant={'secondary'} onClick={() => setCurrentTab('Input')}>
                Choose a different event
              </Button>
            </div>
            <p className="text-base font-semibold">{sizeInBytes(jsonInput)} bytes</p>
          </div>
        </div>
        <div className="flex w-1/2 flex-row items-center justify-between border-r-2 border-gray-300 px-2.5">
          <h3 className="text-base font-semibold">Output</h3>
          <p className="text-base font-semibold">{sizeInBytes(jsonOutput)} bytes</p>
        </div>
      </div>

      {/* Bottom */}
      <Suspense fallback={<h2>Loading...</h2>}>
        <DiffEditor
          height={props.height}
          theme="onedark"
          language="json"
          className="border-x border-b border-gray-300"
          original={deferredInput}
          modified={deferredOutput}
        />
      </Suspense>
    </div>
  )
}
